"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var Icon_1 = __importDefault(require("../Icon"));
var ModalDialog_1 = __importDefault(require("../modals/ModalDialog"));
var ImageEditor_1 = __importDefault(require("../ImageEditor"));
var ImagePreview_1 = __importDefault(require("../ImagePreview"));
var FormError_1 = __importDefault(require("./FormError"));
var Form_1 = require("./Form");
var ImageField = /** @class */ (function (_super) {
    __extends(ImageField, _super);
    function ImageField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = react_1.default.createRef();
        _this.state = {
            dragging: false,
            editorOpen: false,
            failed: false,
            image: null,
            preview: null,
            touched: false
        };
        _this.handleFileSelected = function (event) {
            var files = event.target.files;
            var image = files && files[0];
            _this.handleImageSelected({ editorOpen: !!image, failed: false, image: image || null });
        };
        _this.handleImageEdited = function (image, closeModal) {
            if (closeModal === void 0) { closeModal = false; }
            if (closeModal) {
                _this.setState({ editorOpen: false });
            }
            else {
                var originalImage = _this.state.image;
                var originalImageCopy = originalImage;
                var processedFile = new File([image], (originalImageCopy === null || originalImageCopy === void 0 ? void 0 : originalImageCopy.name) || Math.random().toString(36).substring(2), { type: image.type });
                _this.handleImageSelected({ editorOpen: false, failed: false, image: processedFile }, true);
            }
        };
        _this.handleImageFailure = function () {
            _this.handleImageSelected({ editorOpen: false, failed: true, image: null });
        };
        _this.handleImageSelected = function (_a, finalVersion) {
            var editorOpen = _a.editorOpen, failed = _a.failed, image = _a.image;
            if (finalVersion === void 0) { finalVersion = false; }
            var _b = _this.props, name = _b.name, onChange = _b.onChange, onFormChange = _b.onFormChange;
            _this.setState(function (state) {
                if (state.preview) {
                    URL.revokeObjectURL(state.preview);
                }
                return {
                    editorOpen: editorOpen,
                    failed: failed,
                    image: image,
                    preview: image ? URL.createObjectURL(image) : null,
                    touched: true
                };
            });
            if (onChange) {
                onChange(image, finalVersion);
            }
            onFormChange(name, image);
        };
        _this.handleClose = function () {
            _this.setState({ editorOpen: false });
        };
        _this.handleDragEnter = function () {
            _this.setState({ dragging: true });
        };
        _this.handleDragLeave = function () {
            _this.setState({ dragging: false });
        };
        _this.handleDragOver = function (event) {
            event.preventDefault();
            return false;
        };
        _this.handleDrop = function (event) {
            event.preventDefault();
            var image = event.dataTransfer.files[0];
            _this.handleImageSelected({ editorOpen: !!image, failed: false, image: image || null });
        };
        return _this;
    }
    ImageField.prototype.componentDidMount = function () {
        var autoFocus = this.props.autoFocus;
        var input = this.inputRef.current;
        if (autoFocus && input) {
            input.focus();
        }
    };
    ImageField.prototype.render = function () {
        var _a = this.props, aspectRatio = _a.aspectRatio, autoFocus = _a.autoFocus, backgroundIcon = _a.backgroundIcon, imageAsBackground = _a.imageAsBackground, buttonLabel = _a.buttonLabel, children = _a.children, className = _a.className, disabledStates = _a.disabledStates, errors = _a.errors, name = _a.name, onChange = _a.onChange, onError = _a.onError, onFieldDisabledChange = _a.onFieldDisabledChange, asButtonView = _a.asButtonView, onFormChange = _a.onFormChange, progress = _a.progress, required = _a.required, submitted = _a.submitted, submitting = _a.submitting, validator = _a.validator, value = _a.value, values = _a.values, icon = _a.icon, registerModal = _a.registerModal, props = __rest(_a, ["aspectRatio", "autoFocus", "backgroundIcon", "imageAsBackground", "buttonLabel", "children", "className", "disabledStates", "errors", "name", "onChange", "onError", "onFieldDisabledChange", "asButtonView", "onFormChange", "progress", "required", "submitted", "submitting", "validator", "value", "values", "icon", "registerModal"]);
        var _b = this.state, dragging = _b.dragging, editorOpen = _b.editorOpen, failed = _b.failed, image = _b.image, preview = _b.preview, touched = _b.touched;
        var normal = value || values[name] || null;
        if (asButtonView) {
            return (react_1.default.createElement("label", { className: classnames_1.default("chq-ffd", className, imageAsBackground && "chq-ffd--bg-img"), htmlFor: name },
                react_1.default.createElement("div", { className: "chq-ffd--im chq-ffd--im-btn", onDragEnter: this.handleDragEnter, onDragLeave: this.handleDragLeave, onDragOver: this.handleDragOver, onDrop: this.handleDrop },
                    react_1.default.createElement("div", { className: "chq-btn" },
                        react_1.default.createElement(Icon_1.default, { icon: icon || "upload-image" }),
                        react_1.default.createElement("span", { className: "chq-ffd--im--bt-bg--text" }, buttonLabel || "Upload an image"),
                        react_1.default.createElement("input", __assign({ accept: "image/*", ref: this.inputRef }, props, { type: "file", id: name, name: name, onChange: this.handleFileSelected }))),
                    typeof progress === "number" && (react_1.default.createElement("div", { className: "chq-ffd--im--prog", role: "progressbar", "aria-valuemin": 0, "aria-valuenow": progress, "aria-valuemax": 100 },
                        react_1.default.createElement("div", { style: { width: progress + "%" } })))),
                failed && (react_1.default.createElement("p", { className: "chq-ffd--rq" }, "Not a valid image.")),
                editorOpen && (react_1.default.createElement(ModalDialog_1.default, { onClose: this.handleClose, registerModal: registerModal },
                    react_1.default.createElement(ModalDialog_1.default.Body, null,
                        react_1.default.createElement(ImageEditor_1.default, { aspectRatio: aspectRatio, image: preview, onEdit: this.handleImageEdited, onFailure: this.handleImageFailure }))))));
        }
        return (react_1.default.createElement("div", { className: classnames_1.default(imageAsBackground && "chq-ffd--bg-img-container") },
            imageAsBackground && !editorOpen && (react_1.default.createElement("div", { className: "chq-ffd--bg-img--img", style: { backgroundImage: "url(\"" + (preview || value) + "\")" } })),
            react_1.default.createElement("label", { className: classnames_1.default("chq-ffd", className, imageAsBackground && "chq-ffd--bg-img"), htmlFor: name },
                react_1.default.createElement("span", { className: "chq-ffd--lb" }, children),
                react_1.default.createElement("div", { className: classnames_1.default("chq-ffd--im", { "chq-ffd--im-drag": dragging }), onDragEnter: this.handleDragEnter, onDragLeave: this.handleDragLeave, onDragOver: this.handleDragOver, onDrop: this.handleDrop, style: {
                        overflow: imageAsBackground ? "hidden" : "initial"
                    } },
                    react_1.default.createElement(ImagePreview_1.default, { editorOpen: editorOpen, image: image, imageAsBackground: imageAsBackground, preview: preview || normal }),
                    imageAsBackground ? (react_1.default.createElement("div", { className: "chq-ffd--im--bt-bg" },
                        react_1.default.createElement(Icon_1.default, { icon: icon || "images" }),
                        react_1.default.createElement("span", { className: "chq-ffd--im--bt-bg--text" }, buttonLabel || "Upload an image"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        !normal && (react_1.default.createElement("div", { className: "chq-ffd--im--ph" },
                            react_1.default.createElement(Icon_1.default, { icon: backgroundIcon || icon || "images" }))),
                        react_1.default.createElement("div", { className: "chq-ffd--im--bt" },
                            react_1.default.createElement(Icon_1.default, { icon: icon || "ios-cloud-upload-outline" }),
                            " ",
                            buttonLabel || "Upload an image"))),
                    react_1.default.createElement("input", __assign({ accept: "image/*", ref: this.inputRef }, props, { type: "file", id: name, name: name, onChange: this.handleFileSelected })),
                    typeof progress === "number" && (react_1.default.createElement("div", { className: "chq-ffd--im--prog", role: "progressbar", "aria-valuemin": 0, "aria-valuenow": progress, "aria-valuemax": 100 },
                        react_1.default.createElement("div", { style: { width: progress + "%" } })))),
                failed && (react_1.default.createElement("p", { className: "chq-ffd--rq" }, "Not a valid image.")),
                editorOpen && (react_1.default.createElement(ModalDialog_1.default, { onClose: this.handleClose, registerModal: registerModal },
                    react_1.default.createElement(ModalDialog_1.default.Body, null,
                        react_1.default.createElement(ImageEditor_1.default, { aspectRatio: aspectRatio, image: preview, onEdit: this.handleImageEdited, onFailure: this.handleImageFailure })))),
                react_1.default.createElement(FormError_1.default, { name: name, onError: onError, required: required, submitted: submitted, touched: touched, validator: validator, value: normal }))));
    };
    return ImageField;
}(react_1.default.Component));
exports.default = Form_1.withForm(ImageField);
